import Compressor from 'compressorjs'

export function compression (file) {
  return new Promise((resolve, reject) => {
    return new Compressor(file, {
      quality: 0.6,
      maxWidth: 640,
      maxHeight: 640,
      success (result) {
        resolve(result)
      },
      error (err) {
        reject(err)
      }
    })
  })
}
